var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { buildURI, useFetch } from '@hn-front/utils';
import { ACTIVITY_STREAM_API } from '../../constants/routes';
var useFetchStudentActivityStream = function (studentId, query, fetchProps) {
    if (fetchProps === void 0) { fetchProps = {}; }
    return useFetch(buildURI(ACTIVITY_STREAM_API.studentActivity, {
        pathParams: { studentId: studentId },
        query: {
            date: query.startDate,
            end_date: query.endDate,
        },
    }), __assign({ isCache: false, isStale: true }, fetchProps));
};
export { useFetchStudentActivityStream };
